var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 38,
    viewBox: "0 0 21 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.146 14.0087C14.0334 14.0087 13.9208 14.052 13.8429 14.1386L7.78078 20.2007C7.60758 20.3739 7.60758 20.6423 7.78078 20.8155L13.8429 26.8777C14.0161 27.0422 14.2846 27.0422 14.4578 26.869C14.6223 26.7045 14.6223 26.436 14.4578 26.2628L8.69876 20.5038L14.4578 14.7448C14.631 14.5716 14.631 14.3031 14.4578 14.1299C14.3798 14.052 14.2672 14 14.1547 14L14.146 14.0087Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.27cfb60b20d50faae76d6a07d3e5dfea.svg";
export { ForwardRef as ReactComponent };